import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingWebpConverterConfig } from '@/data/landingConfig/landingWebpConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_WebpConverter } from './schemaObject';

interface Props {}
const WebpConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_WebpConverter} />
			<LandingTemplate
				data={landingWebpConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelWebpConverter()}
			/>
		</>
	);
};

export default WebpConverter;
